// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"618":"995d751f","729":"a338bb4b","787":"dc4086bd","995":"0b638478"}[chunkId] + ".chunk.js";
};